import classNames from 'classnames';
import React from 'react';
import { ACTIVE, DISABLED, DOWNVOTE_BUTTON, PENDING, UPVOTE_BUTTON, VOTE_CONTAINER, VOTE_COUNT, } from '../../../common/constants/data-hooks';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { useApi } from '../../context/api-context/use-api';
import { VoteArrowIcon } from '../icons/vote-arrow-icon';
import VisuallyHidden from '../visually-hidden';
import { TooltipLazy } from '../tooltip-lazy/tooltip-lazy';
import VoteArrow from './vote-arrow/vote-arrow';
import styles from './voting.module.scss';
const Voting = ({ onVote, voteState, isDisabled, className }) => {
    const isMobile = useApi((state) => getIsMobile(state));
    const t = useTranslate();
    const tooltipProps = {
        minWidth: 100,
        showDelay: 1000,
        disabled: isMobile,
        appendTo: 'window',
    };
    const isUpvoteActive = voteState.state === 'UPVOTE';
    const isDownvoteActive = voteState.state === 'DOWNVOTE';
    const upvoteLabel = isUpvoteActive ? t('voting.unupvote-tooltip') : t('voting.upvote-tooltip');
    const downvoteLabel = isDownvoteActive
        ? t('voting.undownvote-tooltip')
        : t('voting.downvote-tooltip');
    const [announcement, setAnnouncement] = React.useState('');
    const handleUpvote = () => {
        if (isDisabled) {
            return;
        }
        const nextVoteState = isUpvoteActive ? 'NEUTRAL' : 'UPVOTE';
        const nextAnnouncement = isUpvoteActive
            ? t('voting.screen-reader.upvote-removed')
            : t('voting.screen-reader.upvote-added');
        onVote(nextVoteState);
        setAnnouncement(nextAnnouncement);
    };
    const handleDownvote = () => {
        if (isDisabled) {
            return;
        }
        const nextVoteState = isDownvoteActive ? 'NEUTRAL' : 'DOWNVOTE';
        const nextAnnouncement = isDownvoteActive
            ? t('voting.screen-reader.downvote-removed')
            : t('voting.screen-reader.downvote-added');
        onVote(nextVoteState);
        setAnnouncement(nextAnnouncement);
    };
    return (React.createElement("div", { "data-hook": classNames(VOTE_CONTAINER, voteState.pending && PENDING, isDisabled && DISABLED), className: classNames(styles.root, isDisabled && styles.isDisabled, className) },
        React.createElement(VisuallyHidden, { "aria-live": "polite", "aria-atomic": "true", role: "status" }, announcement),
        React.createElement(TooltipLazy, { ...tooltipProps, content: React.createElement("div", { style: { textAlign: 'center' } }, upvoteLabel), disabled: isDisabled }, (() => {
            return (React.createElement(VoteArrow, { ariaLabel: upvoteLabel, className: classNames(styles.vote, isUpvoteActive && styles.isActive), dataHook: classNames(UPVOTE_BUTTON, isUpvoteActive && ACTIVE), onClick: handleUpvote, active: isUpvoteActive, component: React.createElement(VoteArrowIcon, null), disabled: isDisabled }));
        })()),
        React.createElement("span", { className: styles.voteCount, "data-hook": VOTE_COUNT, "aria-live": "polite" }, voteState.score),
        React.createElement(TooltipLazy, { ...tooltipProps, content: React.createElement("div", { style: { textAlign: 'center' } }, downvoteLabel), disabled: isDisabled }, (() => {
            return (React.createElement(VoteArrow, { ariaLabel: downvoteLabel, className: classNames(styles.vote, isDownvoteActive && styles.isActive), dataHook: classNames(DOWNVOTE_BUTTON, isDownvoteActive && ACTIVE), onClick: handleDownvote, active: isDownvoteActive, component: React.createElement(VoteArrowIcon, null), flip: true, disabled: isDisabled }));
        })())));
};
export default Voting;
//# sourceMappingURL=voting.js.map